<div  class="row">
    <img [src]="croppedImage" style="width: 20em;height: 20em;object-fit: fill;"/>
</div>